<template>
  <div
    class="card card-default border col-md-12 mb-3"
    style="border-radius: 10px"
  >
    <div
      class="card-header bg-white"
      style="cursor: text !important"
      v-on:mouseleave="hideFullContent"
    >
      <div class="row post-content">
        <div class="col-md-1 col-xs-12" align="center">
          <div class="user-pic">
            <img
              alt="Profile Image"
              :data-src-retina="post | showPicture"
              :data-src="post | showPicture"
              :src="post | showPicture"
              class="img-circle"
              @error="imageUrlAlt"
            />
            <div class="col-md-2 propic-badge" v-if="post.source">
              <i :class="sosmed_icon[post.source] + ' icon-' + post.source"></i>
            </div>
          </div>
        </div>
        <div class="col-md-11">
          <h5>
            <span
              v-if="
                post.source == 'news' ||
                  post.source == 'media_tv' ||
                  post.source == 'media_cetak'
              "
              class="pull-left account-name"
              style="cursor: pointer !important"
              v-on:click="showModal(post)"
            >
              {{ post.title }}
            </span>
            <span
              v-else
              class="pull-left account-name"
              style="cursor: pointer !important"
              v-on:click="showModal(post)"
            >
              <span v-if="post.source === 'twitter'">@</span>{{ post.account }}
              <span
                v-if="is_pers"
                class="bg-orange label text-white p-t-1 p-b-1 fs-10"
                >Pers</span
              >
            </span>
            <span class="pull-right fs-12" style="margin-top: 2px !important">
              <i class="bi bi-calendar-event"></i>
              {{ dateindo(post.date.$date) }}
            </span>
            <div class="clearfix" />
          </h5>
          <div class="d-flex align-items-center p-t-5">
            <div
              v-if="
                post.source == 'news' ||
                  post.source == 'media_tv' ||
                  post.source == 'media_cetak'
              "
              class="engagement-detail"
            >
              <span
                class="m-r-10 m-l-5 post-number hoverable clickable"
                :title="
                  post.source == 'news'
                    ? 'Sumber Online News'
                    : post.source == 'media_cetak'
                    ? 'Sumber Media Cetak'
                    : 'Sumber Media TV'
                "
                @click="showModal(post)"
              >
                <i
                  :class="
                    post.source == 'news'
                      ? 'bi bi-globe-americas'
                      : post.source == 'media_cetak'
                      ? 'bi bi-newspaper'
                      : 'bi bi-tv'
                  "
                >
                </i>
                {{ post.account ? post.account : "Tidak Tercantum" }}
              </span>
            </div>
            <div
              v-else-if="sosmed_list.includes(post.source)"
              class="engagement-detail"
            >
              <span
                v-for="(engagement, e_index) in post.engagement_detail"
                :key="e_index"
                :title="post_attribute[e_index]"
                class="m-r-5 post-number"
              >
                <i :class="post_meta[e_index]" /> {{ engagement }}
              </span>
              <span
                v-if="post.source == 'review'"
                class="m-r-10 m-l-5 post-number"
                title="Score"
              >
                <i class="bi bi-star-fill" /> {{ post.score }}
              </span>
              <span v-if="post.source != 'review'">
                <span class="separator">|</span>

                <span class="m-r-10 m-l-5 post-number" title="Reach">
                  <i class="bi bi-bar-chart" /> {{ post.esmr | kmbFormatter }}
                </span>
                <span class="m-r-10 post-number" title="Follower">
                  <i class="bi bi-people" /> {{ post.followers | kmbFormatter }}
                </span>
              </span>
            </div>
            <span
              v-if="post.source == 'media_tv'"
              class="m-r-10 m-l-5 post-number"
              title="Channel TV - Nama Program"
            >
              <i class="bi bi-tv" />
              {{ post.account ? post.account : "Tidak Tercantum" }} -
              {{ post.program ? post.program : "Tidak Tercantum" }}
            </span>
            <span
              v-if="post.source == 'media_cetak' || post.source == 'media_tv'"
              class="m-r-10 m-l-5 post-number"
              title="Jurnalis"
            >
              <i class="bi bi-person" />
              {{ post.journalist ? post.journalist : "Tidak Tercantum" }}
            </span>
            <span
              v-if="post.source == 'media_cetak' || post.source == 'media_tv'"
              class="m-r-10 m-l-5 post-number"
              title="Ad Value"
            >
              <b>AD</b> IDR
              {{
                post.rate_fc > 0 && post.rate_fc > 0
                  ? post.rate_fc
                  : post.rate_fc > 0 && post.rate_bw == 0
                  ? post.rate_fc
                  : post.rate_fc == 0 && post.rate_bw > 0
                  ? post.rate_bw
                  : 0 | kmbFormatter
              }}
            </span>
            <span
              v-if="post.source == 'news'"
              class="m-r-10 m-l-5 post-number"
              title="Ad Value"
            >
              <b>AD</b> IDR {{ post.ad_value | kmbFormatter }}
            </span>
            <span
              v-if="
                post.source == 'media_cetak' ||
                  post.source == 'media_tv' ||
                  post.source == 'news'
              "
              class="m-r-10 m-l-5 post-number"
              title="Public Relations Value"
            >
              <b>PR</b> IDR {{ post.pr_value | kmbFormatter }}
            </span>
            <span
              v-if="post.source == 'media_cetak'"
              class="m-r-10 m-l-5 post-number"
              title="Nomor Halaman"
            >
              <b>HAL</b> {{ post.page }}
            </span>
            <span v-if="post.sentiment == 1" class="label label-success">
              Positif
            </span>
            <span v-else-if="post.sentiment == -1" class="label label-danger">
              Negatif
            </span>
            <span v-else class="label label-netral"> Netral </span>
            <span
              v-if="
                post.source != 'news' &&
                  post.source != 'media_cetak' &&
                  post.source != 'media_tv'
              "
              :id="'actual-emotion'"
              class="post-number m-l-5"
            >
              <i
                v-if="post.emotion == 0"
                class="bi bi-emoji-neutral"
                style="font-size: 16px"
                title="Netral"
              ></i>
              <i
                v-if="post.emotion == 1"
                class="bi bi-emoji-smile text-success"
                style="font-size: 16px"
                title="Senang"
              ></i>
              <i
                v-if="post.emotion == 2"
                class="bi bi-emoji-dizzy text-warning"
                style="font-size: 16px"
                title="Takut"
              ></i>
              <i
                v-if="post.emotion == 3"
                class="bi bi-emoji-frown text-blue"
                style="font-size: 16px"
                title="Sedih"
              ></i>
              <i
                v-if="post.emotion == 4"
                class="bi bi-emoji-angry text-danger"
                style="font-size: 16px"
                title="Marah"
              ></i>
            </span>
          </div>

          <div class="post-text-content">
            <span
              class="text-content"
              v-html="writeContent(post.content)"
            ></span>
            <div class="row">
              <div class="col-md-12 d-flex">
                <a
                  href="javascript:void(0)"
                  class="ml-auto"
                  v-if="cekString(post.content) || post.in_medias != null"
                  v-on:click="showFullContent()"
                >
                  {{ is_detail ? "Sembunyikan" : "Selengkapnya" }}</a
                >
              </div>
            </div>

            <div
              v-if="post.in_medias != null"
              class="in-medias hide"
              id="media"
            >
              <div
                v-for="(in_media, in_media_index) in post.in_medias"
                :key="in_media_index"
                class="post-img-wrapper"
              >
                <img
                  v-if="in_media.type == 'photo'"
                  :height="in_media.sizes.small.h"
                  :width="in_media.sizes.small.w"
                  :src="in_media.media_url_https"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row post-action m-t-10">
        <div class="col-md-12 col-sm-12 col-lg-12">
          <div class="row">
            <div class="col-md-1">
              <div v-if="isAdmin || isUser" class="form-check success m-b-0">
                <input
                  class="item-checkbox"
                  type="checkbox"
                  v-model="is_checked"
                  :id="'check-' + post._id.$oid"
                  v-on:click="checkItem()"
                />
                <label :for="'check-' + post._id.$oid"></label>
              </div>
            </div>
            <div class="col-md-6">
              <div v-if="post.topics">
                Topik:
                <button
                  aria-label=""
                  v-for="(t, tIndex) in post.topics"
                  :key="tIndex"
                  class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                >
                  {{ showTopicName(t.$oid) }}
                </button>
              </div>
            </div>
            <div class="col-md-5" align="right">
              <a
                class="m-r-10 visit-btn clickable hoverable"
                :href="post.url"
                style="color: #17a2b8 !important; opacity: 1"
                target="__blank"
              >
                <i class="bi bi-box-arrow-up-right"></i> Kunjungi
              </a>

              <a
                class="m-r-10 restore-btn"
                v-if="(isAdmin || isUser) && is_trashbin"
                href="#"
                style="color: #28a745 !important; opacity: 1"
                @click="restorePost()"
              >
                <i class="bi bi-recycle"></i> Kembalikan
              </a>

              <a
                class="delete-btn"
                v-if="(isAdmin || isUser) && is_trashbin"
                href="#"
                style="color: #dc3545 !important; opacity: 1"
                @click="deletePost()"
              >
                <i class="bi bi-trash"></i> Hapus Permanen
              </a>
              <a
                class="delete-btn"
                v-else-if="(isAdmin || isUser) && !is_trashbin"
                href="#"
                style="color: #dc3545 !important; opacity: 1"
                @click="deletePost()"
              >
                <i class="bi bi-trash"></i> Hapus
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import gp from "@/plugins/generalPlugins.js";
import swal from "sweetalert";
import axios from "axios";
import linkifyHtml from "linkifyjs/html";

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["tiktok"] = "bi bi-tiktok";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["review"] = "bi bi-phone";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["media_tv"] = "bi bi-tv";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["news"] = "bi bi-globe-americas";

var post_meta = [];
post_meta["comment"] = "bi bi-chat-fill";
post_meta["rt"] = "bi bi-repeat";
post_meta["share"] = "bi bi-share";
post_meta["like"] = "bi bi-heart-fill";
post_meta["fav"] = "bi bi-heart-fill";

var post_attribute = [];
post_attribute["fav"] = "Like";
post_attribute["like"] = "Like";
post_attribute["rt"] = "Retweet";
post_attribute["share"] = "Share";
post_attribute["comment"] = "Comment";

export default {
  name: "deleted_post_item",
  props: {
    post: Object,
    is_pers: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    stringLimit: {
      type: Number,
      default: function() {
        return 120;
      },
    },
    topics: Object,
    is_trashbin: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    checked: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  data() {
    return {
      sosmed_icon: sosmed_icon,
      post_meta: post_meta,
      post_attribute: post_attribute,
      sosmed_list: [
        "facebook",
        "instagram",
        "twitter",
        "youtube",
        "review",
        "tiktok",
        "forum",
        "blog",
        "linkedin",
      ],
      is_checked: this.checked,
      string_limit: this.stringLimit,
      is_detail: false,
    };
  },
  methods: {
    showModal: function(post) {
      let account = post;
      this.$router.push({
        path: "/detail-akun",
        query: { account: account.account, key: btoa(account.id_account) },
      });
    },
    showFullContent: function() {
      this.is_detail = !this.is_detail;
      if (this.is_detail) {
        this.string_limit = this.post.content.length;
      } else {
        this.string_limit = this.stringLimit;
      }
    },
    createAutoLink: function(text) {
      return linkifyHtml(text, {
        defaultProtocol: "https",
        ignoreTags: ["mark"],
        validate: {
          url: function(value) {
            return /^(http|ftp)s?:\/\//.test(value);
          },
        },
      });
    },
    hideFullContent: function(event) {
      var post_text_content = $(event.target).find(".post-text-content");
      post_text_content.css("-webkit-line-clamp", "2");
    },
    imageUrlAlt: function() {
      event.target.src = "/assets/img/profiles/default.png";
    },
    dateindo: function(tanggal) {
      return gp.dateTimeID(tanggal);
    },
    writeContent: function(text) {
      var batasKata = this.string_limit;
      var newText = text.substring(0, batasKata);
      if (!this.is_detail) {
        newText += "...";
      }

      if ("q" in this.$route.query) {
        newText = this.markString(newText);
      }
      newText = newText.replace(/\n/g, "<br />");

      return newText;
    },
    cekString: function(text) {
      if (text.length > this.stringLimit) {
        return true;
      } else {
        return false;
      }
    },
    deletePost: function() {
      event.preventDefault();
      let params = {
        _id: this.post._id.$oid,
      };
      swal({
        title: "Apakah anda yakin?",
        text:
          "Akan menghapus posting ini. Setelah dihapus permanen, posting tidak akan bisa dikembalikan.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-perma-delete";
          axios
            .post(api, params)
            .then((response) => {
              if (response.status == 200) {
                this.$parent.getData();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function() {
              swal(
                "Error!",
                "Terjadi kesalahan saat menghapus data. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    restorePost: function() {
      event.preventDefault();
      let params = {
        _id: this.post._id.$oid,
      };
      swal({
        title: "Apakah anda yakin?",
        text: "Akan mengembalikan posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "post-restore";
          axios
            .post(api, params)
            .then((response) => {
              if (response.status == 200) {
                this.$parent.getData();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Posting berhasil dikembalikan.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              } else {
                swal(
                  "Error!",
                  "Gagal menghapus data. Silahkan coba lagi.",
                  "warning"
                );
              }
            })
            .catch(function() {
              swal(
                "Error!",
                "Terjadi kesalahan saat mengembalikan posting. Silahkan coba lagi.",
                "warning"
              );
            });
        }
      });
    },
    changeSentimen: function() {
      var tgt = event.target;
      var val_before = this.post.sentiment;
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan mengubah sentimen posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          var newValue = $(tgt)[0].value;
          let params = {
            _id: this.post._id.$oid,
            sentiment: parseInt(newValue),
          };
          let api = process.env.VUE_APP_API_URL + "post-sentiment";
          axios
            .post(api, params)
            .then(function(response) {
              if (response.status == 200) {
                self.post.sentiment = parseInt(newValue);
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Sentimen berhasil diubah.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function() {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah sentimen.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            });
        } else {
          $(tgt).val(val_before);
          this.post.sentiment = val_before;
        }
      });
    },
    checkItem: function() {
      if ($(event.target)[0].checked == true) {
        this.$parent.item_checked.push(this.post._id.$oid);
      } else {
        for (let i = 0; i < this.$parent.item_checked.length; i++) {
          if (this.$parent.item_checked[i] == this.post._id.$oid) {
            this.$parent.item_checked.splice(i, 1);
          }
        }
      }
    },
    showTopicName: function(_id) {
      if (this.topics != null) {
        for (let grup in this.topics.formed) {
          for (let topic in this.topics.formed[grup].topics) {
            if (_id == topic) {
              return this.topics.formed[grup].topics[topic];
            }
          }
        }
        if (_id in this.topics.socmed) {
          return this.topics.socmed[_id];
        } else {
          return false;
        }
      } else {
        return "-";
      }
    },
    markString: function(content) {
      let kata = [];
      if ("q" in this.$route.query) {
        kata = this.$route.query.q;
        kata = gp.extractPhrase(atob(kata));
      }
      kata = [...new Set(kata)];
      kata.forEach(function(word) {
        word = word.replaceAll('"', "");
        word = word.trim();
        let reg_exp = new RegExp("(\\b" + word + "\\b)", "gi");
        content = content.replace(
          reg_exp,
          ` <mark data-markjs="true"> ${word}  </mark> `
        );
      });
      return content;
    },
  },
  filters: {
    decimalFormater: function(value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },
    showPicture: function(post) {
      let pro_pic;
      switch (post.source) {
        case "twitter":
          pro_pic = post.profile_image;
          break;
        case "facebook":
          pro_pic = post.profile_photo;
          break;
        case "youtube":
          pro_pic = post.thumbnails;
          break;
        default:
          pro_pic = "/assets/img/profiles/default.png";
          break;
      }

      if (pro_pic == null) {
        pro_pic = "/assets/img/profiles/default.png";
      }
      return pro_pic;
    },
    kmbFormatter: function(number) {
      return gp.kmbFormatter(number);
    },
  },
  computed: {
    isAdmin: function() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2) {
        return true;
      }
      return false;
    },
    isUser() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 3) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
.perpage-el {
  padding: 0px;
}
.perpage-el i {
  font-size: 18px;
}
.form-sorting-post {
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(33, 33, 33, 0.14);
  border-top-color: rgba(33, 33, 33, 0.21);
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif, sans-serif;
  -webkit-appearance: button;
  color: #212121;
  outline: 0;
  padding: 6px 8px;
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  min-height: 32px;
  -webkit-transition: all 0.12s ease;
  transition: all 0.12s ease;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-transition: background 0.2s linear 0s;
  transition: background 0.2s linear 0s;
}
.input-group-text {
  font-size: 12px;
}
.post-items {
  margin-bottom: 20px;
}
.select2-container {
  z-index: 1 !important;
}
.user-pic {
  width: 100% !important;
  height: auto !important;
}
.img-circle {
  height: auto !important;
  width: 100% !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}
.twitter-border {
  border: 2px solid skyblue;
}

.post-action {
  display: block;
}
.select-sentimen {
  background: none;
  border-radius: 3px;
  font-size: 12px;
  padding: 1px 5px;
  font-weight: bold;
  opacity: 1 !important;
  cursor: pointer;
}
.sentimen-positif {
  border-color: #28a745;
  color: #28a745;
}
.sentimen-negatif {
  border-color: #dc3545;
  color: #dc3545;
}
.sentimen-netral {
  border-color: #007bff;
  color: #007bff;
}
.propic-badge {
  position: absolute;
  right: 20%;
  top: 40px;
  font-size: 12px;
  background: white;
  border-radius: 50%;
  border: 2px #eee solid;
  padding: 1px;
  height: 25px;
  width: 25px;
  max-width: 100%;
}
.post-content:hover .post-number {
  color: black;
  opacity: 1 !important;
}
.active {
  background: #0f8ff9 !important;
  color: #fff !important;
}
a:hover {
  color: blue !important;
  opacity: 1 !important;
}
#action-tersembunyi {
  display: none;
}
.engagement-detail {
  margin-right: 10px;
}
@media (max-width: 600px) {
  .propic-badge {
    position: absolute;
    right: 40%;
    top: 40px;
    font-size: 14px;
    background: white;
    border-radius: 50%;
    border: 1px #eee solid;
    padding: 2px 1px;
    height: 25px;
    width: 25px;
  }
}
select:after {
  content: " ";
  display: inline-block;
  width: 24px;
  height: 24px;
  background: blue;
}
.account-name:hover {
  color: blue;
}
.label-netral {
  background-color: #0e6d87;
  color: white;
}
</style>
